(function() {
  'use strict';
  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = function() {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  function initVideoFacades() {
    const facades = document.querySelectorAll('.video-facade:not([data-initialized])');
    
    facades.forEach(function(facade) {
      const videoSrc = facade.getAttribute('data-video-src');
      const isAutoplay = facade.getAttribute('data-autoplay') === 'true';
      const isControls = facade.getAttribute('data-controls') === 'true';
      const poster = facade.querySelector('.video-poster');
      const playButton = facade.querySelector('.play-button-overlay');
      const videoContainer = facade.querySelector('.video-container');
      
      if (!videoSrc) return;
      
      facade.setAttribute('data-initialized', 'true');
      
      function loadVideo() {
        if (videoContainer.querySelector('video')) return;
        
        facade.classList.add('loading');
        
        const video = document.createElement('video');
        video.src = videoSrc;
        video.preload = 'none';
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        // console.log(facade, isControls)
        if (isAutoplay) {
          video.autoplay = true;
          video.muted = true;
          video.loop = true;
          video.controls = false;
          video.playsInline = true;
          video.setAttribute('webkit-playsinline', 'true');
        } else {
          video.controls = true;
        }
        
        if(!isControls) {
          video.removeAttribute('controls');
        }
        if (video.fetchPriority !== undefined) {
          video.fetchPriority = 'high';
        }
        
        video.addEventListener('loadedmetadata', function() {
          poster.style.display = 'none';
          videoContainer.style.display = 'block';
          facade.classList.remove('loading');
          
          video.play().catch(function(error) {
            console.warn('Video autoplay failed:', error);
          });
        });
        
        video.addEventListener('error', function() {
          facade.classList.remove('loading');
          console.warn('Video failed to load:', videoSrc);
          
          if (playButton) {
            playButton.innerHTML = '<span style="color: red; font-size: 14px;">Video unavailable</span>';
          }
        });
        
        video.addEventListener('play', function() {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'video_play', {
              'video_url': videoSrc,
              'autoplay': isAutoplay
            });
          }
        });
        
        videoContainer.appendChild(video);
        video.load();
      }
      
      if (isAutoplay) {
        if (document.readyState === 'complete') {
          requestAnimationFrame(function() {
            setTimeout(loadVideo, 200);
          });
        } else {
          window.addEventListener('load', function() {
            requestAnimationFrame(function() {
              setTimeout(loadVideo, 200);
            });
          });
        }
      } else {
        const clickHandler = debounce(loadVideo, 100);
        poster.addEventListener('click', clickHandler);
        
        if (playButton) {
          playButton.addEventListener('click', function(e) {
            e.stopPropagation();
            clickHandler();
          });
        }
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoFacades);
  } else {
    initVideoFacades();
  }
  
  document.addEventListener('shopify:section:load', initVideoFacades);
  document.addEventListener('shopify:block:select', initVideoFacades);
  
})();
